// API de Iptel. En producción es siempre developer.iptel.com.ar.
// REACT_APP_IPTEL_URL solo se usa para la vista previa del VPS, donde la API se
// reenvía por el mismo origen (/iptel) porque Iptel solo acepta llamadas del
// navegador desde ventas.iptel.com.ar.
export const BASE_URL = process.env.REACT_APP_IPTEL_URL || "https://developer.iptel.com.ar";
